module.exports = __webpack_public_path__ + "img/arrow-top-gray.80b9056b.svg";